import moment from 'moment'
import _ from 'lodash'
import axios from 'axios'
import { ActionContext } from 'vuex'
import { IState } from '@/store/service/state'
import { commonState } from '../service/state'
import { commonMutations } from '../service/mutations'
import { commonGetters } from '../service/getters'
import { findAll, findByPk, createItem, updateItem, addNewItem, resetState, deleteItem, changeDeletionMark } from '../service/actions'

import BasicObject from '@/dto/AdditionalParameter.json'
const apiUrl = 'additional_parameters'

export const state = Object.assign({}, _.cloneDeep(commonState))

export const mutations = { ...commonMutations }

export const actions = {
  async findAll(context: ActionContext<IState, any>, payload: any) {
    return findAll(context, apiUrl, payload)
  },

  async findByPk(context: ActionContext<IState, any>, payload: any) {
    return findByPk(context, apiUrl, payload, itemHundler)
  },

  async create(context: ActionContext<IState, any>, payload: any) {
    return createItem(context, apiUrl, payload)
  },

  async update(context: ActionContext<IState, any>, payload: any) {
    return updateItem(context, apiUrl, payload)
  },

  async delete(context: ActionContext<IState, any>, payload: any) {
    return deleteItem(context, apiUrl, payload)
  },

  async changeDeletionMark(context: ActionContext<IState, any>, payload: any) {
    return changeDeletionMark(context, apiUrl, payload)
  },

  async addNew(context: ActionContext<IState, any>, payload: any) {
    return addNewItem(context, { basicObject: BasicObject }, payload)
  },

  async getSelectFields() {
    return [
      { key: 'name', label: 'table.name', sortable: true },
      { key: 'predefinedName', label: 'table.predefinedName', sortable: true },
    ]
  },

  async getTypes() {
    return [
      { value: 'text', text: 'fm.components.fields.text' },
      { value: 'number', text: 'fm.components.fields.number' },
      { value: 'date', text: 'fm.components.fields.date' },
      { value: 'datetime', text: 'fm.components.fields.datetime' },
      { value: 'time', text: 'fm.components.fields.time' },
      { value: 'switch', text: 'fm.components.fields.switch' },
      { value: 'textarea', text: 'fm.components.fields.textarea' },
    ]
  },

  async getModels() {
    return axios.get(`${apiUrl}/models`)
  },

  resetState(context: ActionContext<IState, any>) {
    resetState(context)
  },
}

function itemHundler(itemData: any) {
  itemData.object.createdAt = moment(itemData.object.createdAt).format('DD.MM.YYYY HH:mm:ss')
}

export const getters = { ...commonGetters }
